import { tokenSelector } from '@/redux/features/auth.slice';
import { accountSelector } from '@/redux/features/plan.slice';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

function useAffiliate() {
  const { shopId } = useSelector(accountSelector);
  const { shop } = useSelector(tokenSelector);

  useEffect(() => {
    // Chỉ load script khi có đủ thông tin shop
    if (shopId && shop) {
      const appId = '4911567';
      const scriptId = 'affiliate-fingerprint-script';

      // Kiểm tra xem script đã được load chưa
      if (!document.getElementById(scriptId)) {
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = `https://partners.omegatheme.com/s/api/affiliates/script.js?appId=${appId}&shopDomain=${shop}&shopId=${shopId}`;
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }, [shop, shopId]);
  return null;
}

export default useAffiliate;
